var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrapper"},[_c('div',{staticClass:"error-title"},[_vm._v(_vm._s(_vm.$t('contentWizard.preview.renderFailed')))]),_c('div',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.userErrorMessage)+" "),_c('div',{staticClass:"error"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.escapedErrorWithLineBreaks)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }